module.exports = __webpack_public_path__ + "img/chat-24px.6dcbc3d5.svg";